import { render, staticRenderFns } from "./WorkPacksStats.vue?vue&type=template&id=686e7d2c&"
import script from "./WorkPacksStats.vue?vue&type=script&lang=js&"
export * from "./WorkPacksStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686e7d2c')) {
      api.createRecord('686e7d2c', component.options)
    } else {
      api.reload('686e7d2c', component.options)
    }
    module.hot.accept("./WorkPacksStats.vue?vue&type=template&id=686e7d2c&", function () {
      api.rerender('686e7d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workPacks/components/components/WorkPacksStats.vue"
export default component.exports